import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CmsMenuAccountComponent, FeedBadgeType } from '../../../../core/model';
import { FeedFacade, PrincipalConfigurationService, UserFacade } from '../../../../core/user';
import { UserUtilService } from '../../../../core/user/services/user-util.service';
import { MenuService } from '../../services/menu.service';

@Component({
  selector: 'py-menu-account',
  templateUrl: './menu-account.component.html',
  styleUrls: ['./menu-account.component.scss'],
  standalone: false,
})
export class MenuAccountComponent implements OnInit, OnDestroy {
  isAuthenticated$: Observable<boolean>;
  hasActiveMenuItem$: Observable<boolean>;
  notificationCount$: Observable<number>;
  isMyPageActive$: Observable<boolean>;
  userFirstName$: Observable<string>;
  shouldDisplayUserFirstname$: Observable<boolean>;

  private pollingSubs: Subscription;

  constructor(
    public component: CmsComponentData<CmsMenuAccountComponent>,
    private authService: AuthService,
    private menuService: MenuService,
    private feedService: FeedFacade,
    private userService: UserFacade,
    private principalConfigurationService: PrincipalConfigurationService,
    private userUtilService: UserUtilService
  ) {}

  ngOnInit() {
    this.isAuthenticated$ = this.authService.isUserLoggedIn();
    this.hasActiveMenuItem$ = this.menuService.hasActiveLinkUid();

    this.isMyPageActive$ = this.menuService.getIsMyPageActive();

    this.initNotifcationCountObservables();

    this.userFirstName$ = this.userService.get().pipe(
      filter((user) => user && !!Object.keys(user).length),
      map((user) => user.firstName)
    );

    this.shouldDisplayUserFirstname$ = this.principalConfigurationService.isEnabled('displayUserFirstnameInHeader');
  }

  initNotifcationCountObservables() {
    this.notificationCount$ = this.feedService.getFeedData().pipe(
      filter((feedData) => !!feedData),
      map((feedData) => {
        let notificationCount = 0;
        notificationCount += this.userUtilService.getCountForBadgeType(feedData.badges, FeedBadgeType.PENDING_APPROVAL_ORDERS);
        notificationCount += this.userUtilService.getCountForBadgeType(feedData.badges, FeedBadgeType.RETURNED_ORDERS);
        notificationCount += this.userUtilService.getCountForBadgeType(
          feedData.badges,
          FeedBadgeType.SHOPPING_LISTS_WITH_UNAVAILABLE_ARTICLES_COUNT
        );
        notificationCount += this.userUtilService.getCountForBadgeType(
          feedData.badges,
          FeedBadgeType.ORDER_CARDS_WITH_UNAVAILABLE_PRODUCTS_COUNT
        );
        notificationCount += this.userUtilService.getCountForBadgeType(
          feedData.badges,
          FeedBadgeType.AREAS_OF_USE_UNAVAILABLE_PRODUCTS_COUNT
        );
        notificationCount += this.userUtilService.getCountForBadgeType(feedData.badges, FeedBadgeType.NEW_USERS_COUNT);
        notificationCount += this.userUtilService.getCountForBadgeType(feedData.badges, FeedBadgeType.LOCKED_OUT_USERS_COUNT);

        return notificationCount;
      })
    );
  }

  ngOnDestroy(): void {
    if (this.pollingSubs) {
      this.pollingSubs.unsubscribe();
    }
  }
}
